module.exports = __webpack_public_path__ + "media/images/front/programs/icon-checkbox-off-4aa130a2b8691615f57bc08e256c6444.svg";